import { ArrowUp, Crosshair } from "lucide-react";
import Logo from "./Logo";
import { scrollToSection } from "./LenisProvider";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL, LOCATION } from "./constants";

const LINKS = [
  { id: "inicio", label: "Início" },
  { id: "servicos", label: "Serviços" },
  { id: "projetos", label: "Projetos" },
  { id: "empresa", label: "A Empresa" },
  { id: "atuacao", label: "Área de Atuação" },
  { id: "contato", label: "Contato" },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/[0.07] bg-deep/60 overflow-hidden">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <Logo className="h-10" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              Precisão que define o seu projeto. Soluções topográficas para
              construção civil, agronegócio e regularização fundiária.
            </p>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">
              Navegação
            </p>
            <ul className="mt-5 space-y-3">
              {LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToSection(l.id)}
                    className="text-sm text-slate-300 hover:text-dm-glow transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">
              Contato
            </p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li>
                <a href={`tel:${PHONE_TEL}`} className="hover:text-dm-glow transition-colors" data-testid="footer-phone">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="hover:text-dm-glow transition-colors break-all" data-testid="footer-email">
                  {EMAIL}
                </a>
              </li>
              <li>{LOCATION}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-7 border-t border-white/[0.07] flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500 text-center">
            © 2026 DM Levantamentos Topográficos. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <p className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] text-slate-600">
              <Crosshair size={11} className="text-dm-glow/60" />
              3°43′02″S · 38°32′35″W
            </p>
            <button
              data-testid="footer-back-to-top"
              onClick={() => scrollToSection("inicio")}
              aria-label="Voltar ao topo"
              className="h-10 w-10 rounded-full border border-white/10 flex items-center justify-center text-slate-400 hover:text-white hover:border-dm-glow/60 transition-all"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
